import React, { useEffect, useState } from 'react';
import { Tabs, Link, Drawer } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isVoid } from '@/utils/common';
import ModalHeader from '@/components/Header/Modal';
import { reset } from '@/slices/messageTrace';
import BuriedWrapper from '@/components/BuriedWrapper';
import TraceDetail from './TraceDetail';
import Detail from './Detail';

function MessageDetail({ fetchMessageById, reset, clusterName, row, linkText, ...others }) {
  const { messageId, partition, batchIndex, topic } = row;
  const [visible, setVisible] = useState(false);
  const fullMessageName = `${messageId}:${partition}${isVoid(batchIndex) ? '' : `:${batchIndex}`}`;

  useEffect(() => {
    if (!visible) {
      reset();
    }
  }, [visible, reset]);

  const onClose = () => {
    setVisible(false);
  };

  const showDetail = () => {
    setVisible(true);
  };

  const messageParams = {
    ...row,
    clusterName,
    fullMessageName,
  };

  const tabList = [
    {
      label: '消息轨迹',
      value: '1',
      panel: <TraceDetail row={messageParams} />,
    },
    {
      label: '消息详情',
      value: '2',
      panel: <Detail row={messageParams} />,
    },
  ];

  return (
    <>
      <BuriedWrapper eventId='MESSAGE_TRACE_DETAIL_TRACE_INFO'>
        <Link onClick={showDetail} theme='primary' {...others}>
          {linkText || fullMessageName}
        </Link>
      </BuriedWrapper>
      <Drawer
        size={1200}
        header={<ModalHeader tags={[clusterName, topic, messageId]}>轨迹详情</ModalHeader>}
        visible={visible}
        onClose={onClose}
        destroyOnClose
        onOverlayClick={onClose}
        footer={null}
      >
        <Root>
          <Tabs
            style={{ marginTop: -8 }}
            placement={'top'}
            size={'medium'}
            defaultValue={'1'}
            list={tabList}
          />
        </Root>
      </Drawer>
    </>
  );
}

export default connect(null, {
  reset,
})(MessageDetail);

// 内容只有Tab，样式需特殊处理
const Root = styled.div`
  .descriptions {
    margin-top: 24px;
  }
  .t-tabs__nav-container.t-is-top {
    margin-left: -8px;
    &::after {
      background-color: transparent;
    }
  }
  div.t-tabs__bar.t-is-top {
    &[style*='width'] {
      width: 56px !important;
      margin-left: 8px;
    }
    .t-tab-panel {
      padding-left: 6px;
    }
  }

  .t-tabs__nav-item-wrapper {
    margin: 0;
  }

  .t-tabs__nav-item.t-size-m {
    height: 40px;
  }
  .t-tabs__nav {
    min-height: 0 !important;
  }
`;
